import React from "react";
import { MessageCircle } from "lucide-react";

const WhatsAppButton = () => {
  return (
    <a
      href="https://wa.me/916360283627?text=Hi%20PrintzKart%2C%20I%20need%20a%20quote%20for%203D%20printing."
      target="_blank"
      rel="noopener noreferrer"
      className="whatsapp-float"
      aria-label="Chat on WhatsApp"
    >
      <svg viewBox="0 0 32 32" width="28" height="28" fill="white">
        <path d="M16.004 0h-.008C7.174 0 0 7.176 0 16.004c0 3.5 1.128 6.744 3.046 9.378L1.054 31.27l6.118-1.958a15.923 15.923 0 008.832 2.692C24.826 32 32 24.826 32 16.004 32 7.176 24.826 0 16.004 0zm9.55 22.606c-.396 1.118-2.326 2.142-3.21 2.24-.884.1-1.702.396-5.73-1.192-4.846-1.912-7.95-6.892-8.19-7.212-.238-.32-1.952-2.596-1.952-4.952s1.234-3.514 1.674-3.994c.44-.48.96-.6 1.28-.6.32 0 .64.002.918.016.296.016.692-.112 1.082.826.396.952 1.352 3.312 1.472 3.552.12.24.198.52.04.838-.16.32-.24.518-.478.798-.24.28-.504.624-.72.838-.238.24-.488.498-.21.976.28.48 1.242 2.05 2.668 3.32 1.834 1.634 3.378 2.14 3.858 2.38.48.24.76.198 1.04-.12.278-.318 1.198-1.396 1.518-1.876.318-.48.638-.396 1.078-.238.44.16 2.794 1.318 3.274 1.558.48.24.798.358.918.558.118.198.118 1.156-.278 2.274z"/>
      </svg>
    </a>
  );
};

export default WhatsAppButton;
